import MainTopSection from "./MainTopSection"
import MainServices from "./MainServices"
import Warranty from "./Warranty"
import MainTopMessage from "./MainTopMessage"
import MainBrands from "./MainBrands"
import MainBottomMessage from "./MainBottomMessage"
import Footer from "../Footer"
import { Fade } from "@mui/material"
import timeout from "../../data/timeout"
import { logMessage } from "../../utils/utils"
import Contacts from "../routes/Contacts"
import Prices from "../routes/Prices"
import OrderForm from "../routes/OrderForm"

const Main = () => {
  logMessage("Головна")
  return (
    <Fade timeout={timeout} in>
      <main className="mb-32">
        <MainTopSection />
        <MainTopMessage />
        <MainServices />
        <Warranty />
        <MainBrands />
        {/* <MainBottomMessage /> */}
        {/* <Prices /> */}
        <Contacts />
        {/* <OrderForm /> */}
        {/* <Footer /> */}
      </main>
    </Fade>
  )
}

export default Main
